import React from 'react';
import { IEntity, IRiskAppHeatMapColor } from '../../types';
import { RagIndicatorForRisk } from './RagIndicatorForRisk';


export interface IRiskRagIndicatorProps {
    impactLevel: IEntity;
    probability: IEntity;
    riskScoreFormula: string | null;
    riskAppHeatMapColors: IRiskAppHeatMapColor[];
}

export const RiskRagIndicator = ({ impactLevel, probability, riskScoreFormula, riskAppHeatMapColors }: IRiskRagIndicatorProps): React.ReactElement => {

    const label =
        impactLevel && probability
            ? `${impactLevel?.Title}/${probability?.Title}`
            : `To be completed`;

    return <RagIndicatorForRisk
        label={label}
        impactLevelID={impactLevel?.ID ?? null}
        probabilityID={probability?.ID ?? null}
        riskScoreFormula={riskScoreFormula}
        riskAppHeatMapColors={riskAppHeatMapColors}
    />;
};
